import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { DisclaimerType } from '@/modules/disclaimer/constants/DisclaimerType';

export class Disclaimer extends BaseEntityModel {
  id?: number;
  estateId?: number;
  userId?: number;
  type: string;

  constructor(model: Partial<Disclaimer> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.userId = model.userId;
    this.type = model.type as string;
  }

  get isBasicPlanRegistrationDisclaimer(): boolean {
    return this.type === DisclaimerType.FINALIZE_BASIC_PLAN_REGISTRATION;
  }

  get isStandardPlanRegistrationDisclaimer(): boolean {
    return this.type === DisclaimerType.FINALIZE_STANDARD_PLAN_REGISTRATION;
  }
}
